import { c as _c } from "react/compiler-runtime";
import { captureMessage } from "@sentry/nextjs";
import { isChannel } from "@website/utils/channel/helpers";
import { NewPasswordCard, OtpCard, PasswordCard, PasswordChangeSuccessfulCard, PhoneNumberCard } from "@website/widget/login/components";
import styles from "@website/widget/login/login.module.scss";
import { LoginPropertiesType, LoginStepType } from "@website/widget/login/login.types";
import { useLogin } from "@website/widget/login/use-login";
import { useEffect } from "react";
export const Login = properties => {
  const $ = _c(38);
  const {
    onEndAuth,
    onClose,
    isWelcomeScreen,
    isForceLogin
  } = properties;
  const {
    step,
    setStep,
    userData,
    setUserData
  } = useLogin();
  let t0;
  if ($[0] !== setStep) {
    t0 = step_0 => {
      setStep(step_0);
    };
    $[0] = setStep;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const setStepHandler = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useEffect(_temp, t1);
  let t2;
  if ($[3] !== isForceLogin || $[4] !== isWelcomeScreen || $[5] !== onClose || $[6] !== setStepHandler || $[7] !== setUserData || $[8] !== step || $[9] !== userData) {
    t2 = step === "phone-number" && <PhoneNumberCard onClose={onClose} setStep={setStepHandler} setUserData={setUserData} userData={userData} isWelcomeScreen={isWelcomeScreen} isForceLogin={isForceLogin} />;
    $[3] = isForceLogin;
    $[4] = isWelcomeScreen;
    $[5] = onClose;
    $[6] = setStepHandler;
    $[7] = setUserData;
    $[8] = step;
    $[9] = userData;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== onClose || $[12] !== onEndAuth || $[13] !== setStepHandler || $[14] !== setUserData || $[15] !== step || $[16] !== userData) {
    t3 = step === "otp" && <OtpCard onClose={onClose} onEndAuth={onEndAuth} setStep={setStepHandler} setUserData={setUserData} userData={userData} />;
    $[11] = onClose;
    $[12] = onEndAuth;
    $[13] = setStepHandler;
    $[14] = setUserData;
    $[15] = step;
    $[16] = userData;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  let t4;
  if ($[18] !== onClose || $[19] !== onEndAuth || $[20] !== setStepHandler || $[21] !== setUserData || $[22] !== step || $[23] !== userData) {
    t4 = step === "password" && <PasswordCard onClose={onClose} onEndAuth={onEndAuth} setStep={setStepHandler} setUserData={setUserData} userData={userData} />;
    $[18] = onClose;
    $[19] = onEndAuth;
    $[20] = setStepHandler;
    $[21] = setUserData;
    $[22] = step;
    $[23] = userData;
    $[24] = t4;
  } else {
    t4 = $[24];
  }
  let t5;
  if ($[25] !== onEndAuth || $[26] !== setStepHandler || $[27] !== step || $[28] !== userData) {
    t5 = step === "forgot-password" && <NewPasswordCard onEndAuth={onEndAuth} setStep={setStepHandler} userData={userData} />;
    $[25] = onEndAuth;
    $[26] = setStepHandler;
    $[27] = step;
    $[28] = userData;
    $[29] = t5;
  } else {
    t5 = $[29];
  }
  let t6;
  if ($[30] !== step) {
    t6 = step === "password-change-successful" && <PasswordChangeSuccessfulCard />;
    $[30] = step;
    $[31] = t6;
  } else {
    t6 = $[31];
  }
  let t7;
  if ($[32] !== t2 || $[33] !== t3 || $[34] !== t4 || $[35] !== t5 || $[36] !== t6) {
    t7 = <div className={styles.container}>{t2}{t3}{t4}{t5}{t6}</div>;
    $[32] = t2;
    $[33] = t3;
    $[34] = t4;
    $[35] = t5;
    $[36] = t6;
    $[37] = t7;
  } else {
    t7 = $[37];
  }
  return t7;
};
function _temp() {
  const isB2b = isChannel(["b2b"]);
  if (isB2b) {
    captureMessage("B2C login modal is open inside B2B", {
      level: "log",
      extra: {
        url: window.location.href,
        referrer: document.referrer
      }
    });
  }
}